import { Component, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'customer-app-intro',
  templateUrl: './intro.component.html',
  styleUrls: ['./intro.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class IntroComponent {
  private translateService = inject(TranslateService);

  readonly maxHeight = input<string>(undefined);

  get textContent(): string {
    return this.translateService.instant('guided-tour.intro-text');
  }
}
